import $http from '@vue-util/http';
import { getUserIds } from '@utils/cookiesUtils';

export class PzoService {
  constructor(isProduction, productIds) {
    const { userGuid, userId } = getUserIds();
    this.isProduction = isProduction;
    this.productIds = productIds;
    this.userGuid = userGuid;
    this.userId = userId;
  }

  _apiUrl = '/api/order/v3/promotions/pzoProducts';

  static PZO_NOT_ELIGIBLE_DATA = 'X-User-Pzo-Eligible';

  static PZO_USER_ELIGIBLE_HEADER = 'x-user-pzo-eligible';

  static setOptimizationParameter() {
    localStorage.setItem(PzoService.PZO_NOT_ELIGIBLE_DATA, JSON.stringify({ userId: getUserIds().userId, timestamp: Date.now() }));
  }

  createUrl = (apiUrl, userId, productIds) => `${apiUrl}?userId=${userId}&productIds=${productIds}`

  getPzoEligible = async () => {
    try {
      const response = await $http.get(
        this.createUrl(
          this._apiUrl,
          this.userId,
          this.productIds,
        ),
        {
          headers: {
            'X-Macys-User-Guid': this.userGuid,
          },
        },
      );

      if ((response.headers[PzoService.PZO_USER_ELIGIBLE_HEADER] === 'false')) {
        PzoService.setOptimizationParameter();
      }

      return response.data;
    } catch (e) {
      throw this._handleError(e, 'Pzo fetching error');
    }
  }

  _handleError(error, message) {
    return error.response ? Error(message) : Error(error.message || message);
  }

  static isPzoOptimizationDisabled(pzoData, currentUserId) {
    if (!pzoData) {
      return true;
    }

    const pzoDataObj = JSON.parse(pzoData);
    return (Date.now() - +pzoDataObj.timestamp > 2700000) || pzoDataObj.userId !== currentUserId; // 2700000 - 45min
  }

  static showPzo(isMcom, pzoBadgingEnabled) {
    const { userId, userGuid } = getUserIds();
    return pzoBadgingEnabled
    && isMcom
    && userId
    && userGuid
    && this.isPzoOptimizationDisabled(localStorage.getItem(PzoService.PZO_NOT_ELIGIBLE_DATA), userId);
  }
}

export default PzoService;
